<template lang="pug">
v-tabs.rounded-lg.dashboard-pages(
  v-model="tab",
  color="white",
  active-class="primary",
  height="23",
  hide-slider,
  show-arrows,
)
  template(v-for="dboard in dashboards")
    v-tab(:key="dboard.uid") {{ dboard.title }}
  v-tabs-items(v-model="tab")
    template(v-for="dboard in dashboards")
      v-tab-item(:key="dboard.uid")
        dashboard-component(:dashboard="dboard" :chartsList="charts")
</template>

<style lang="scss" scoped>
.dashboard-pages {
  ::v-deep .v-slide-group__wrapper {
    border-radius: 5px;
  }

  ::v-deep .v-slide-group__next,
  ::v-deep .v-slide-group__prev {
    background-color: var(--v-background-base);
  }

  ::v-deep .v-tabs-bar__content {
    background-color: #E0E0EE;

    .v-tab {
      letter-spacing: 0;
      font-size: 11px;
      &--active {
        border-radius: 5px;
      }
    }
  }

  ::v-deep .v-tabs-items {
    background: none;
  }
}
</style>

<script>
export default {
  name: 'DashboardPages',
  props: {
    dashboards: {
      type: Array,
      default: () => ([]),
    },
    charts: {
      type: Array,
      default: () => ([]),
    }
  },
  data () {
    return {
      tab: null,
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
